module.exports = __webpack_public_path__ + "img/20200609_144806.75e5d2d9.jpg";